// Initialize your components on DOM Ready.
window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.preloadAfterLoad = true
require('lazysizes');
import AOS from 'aos';
import Rellax from 'rellax';  
// import Swup from 'swup'; 
// import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupGiaPlugin from '@swup/gia-plugin';
// import SwupScrollPlugin from '@swup/scroll-plugin';
// import JsPlugin from './swup/plugins/JsPlugin'
// import DebugPlugin from '@swup/debug-plugin';
// import transitions from './swup/transitions/transitions'
import loadComponents from 'gia/loadComponents'
import components from './components' 
import Global from './global' 
loadComponents(components);

  init();
  
  function init() {
    document.documentElement.classList.remove('no-js');
    document.documentElement.classList.add('js');
    AOS.init({
      duration: 800,
      easing: 'ease-out'
    });
    Global.init();
  }
    